<div class="dashboard-holder p-3">
    <div class="dashboard-content">

        <div class="analytics-container">
            <div class="page-title d-flex justify-content-between align-items-center">
                <h3>Dashboard</h3>
                <div class="date-sets">
                    <p-calendar 
                      [(ngModel)]="dateRange" 
                      selectionMode="range" 
                      appendTo="body"
                      (onSelect)="onDateRangeChange()"
                      [numberOfMonths]="2">
                    </p-calendar>
                  </div>
                  
            </div>
            <div>
                <!-- <h5 class="mt-3 fw-normal">Lead & Status Overview</h5> -->
                <div class="analytics-overview-container mt-2">

                    <div class="metrics-card bg-blue">
                        <div class="d-flex align-items-center justify-content-between gap-3 flex-column flex-lg-row text-center">
                            <div>
                                <h4 class="m-0">Leads</h4>
                            </div>
                            <div class="d-flex align-items-center gap-4">
                                <h2 class="m-0">{{followUpsSummary?.totalCount}}</h2>
                                <i class="pi pi-crown m-0"></i>
                            </div>
                        </div>
                    </div>
                    <div class="metrics-card bg-blue">
                        <div class="d-flex align-items-center justify-content-between gap-3 flex-column flex-lg-row text-center">
                            <div>
                                <h4 class="m-0">Tour Scheduled</h4>
                            </div>
                            <div class="d-flex align-items-center gap-4">
                                <h2 class="m-0">{{followUpsSummary?.activeCount}}</h2>
                                <i class="pi pi-calendar-minus m-0"></i>
                            </div>
                        </div>
                    </div>
                    <div class="metrics-card bg-blue">
                        <div class="d-flex align-items-center justify-content-between gap-3 flex-column flex-lg-row text-center">
                            <div>
                                <h4 class="m-0">Complete</h4>
                            </div>
                            <div class="d-flex align-items-center gap-4">
                                <h2 class="m-0">{{followUpsSummary?.completeCount}}</h2>
                                <i class="pi pi-check-circle m-0"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="pipeline-overview">
            <!-- <h5 class="fw-normal">Status Insights</h5> -->
            <div class="pipeline-overview-sec-container">
                <div class="pipeline-step" *ngFor="let status of pipelineStatuses">
                    <p class="title">{{ status.title }}</p>
                    <div class="pipeline-card-container">
                        <div class="pipeline-card"
                            *ngFor="let record of followUpsSummary?.topRecords[status.key] || []">
                            <p class="m-0">{{ record.customer_name }}</p>
                            <!-- <p class="m-0 mt-2">{{ record.property_name }}</p> -->
                            <p class="m-0">{{ record.plan_name }}</p>
                            <p class="m-0" *ngIf="record.user_name">Assigned: <b>{{ record.user_name}} </b></p>
                            <p class="m-0">{{ record.date+' '+record.time | timezoneDate:propTimeZone:'datetime' }}</p>
                            <!-- <p class="m-0">{{ record.time }}</p> -->

                        </div>
                        <div class="pipeline-card" *ngIf="!followUpsSummary?.topRecords[status.key]?.length">
                            <p>No records available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="calendar-holder p-4 m-1 mt-5">
        <full-calendar [options]="calendarOptions"></full-calendar>
    </div>

    <div class="meeting-details">
        <p-dialog [(visible)]="displayModal" header="Meeting Details" [modal]="true" [closable]="true">
            <ng-container *ngIf="meetingDetails">
                <div class="details d-flex flex-column gap-2">
                    <small><i class="pi pi-calendar-clock mr-rt"></i><strong> Start Time: </strong>{{ meetingDetails.start | timezoneDate:propTimeZone:'datetime' }}</small>
                    <small><i class="pi pi-user"></i><strong>Name: </strong> {{ meetingDetails.name }}</small>
                    <small><i class="pi pi-envelope"></i><strong>Email: </strong> {{ meetingDetails.email }}</small>
                    <small><i class="pi pi-phone"></i><strong>Phone: </strong> {{ meetingDetails.customerPhone }}</small>
                    <small><i class="pi pi-building"></i><strong>Property Name:</strong>  {{ meetingDetails.propertyName }}</small>
                    <small><i class="pi pi-home"></i><strong>Plan: </strong> {{ meetingDetails.plan }}</small>
                    <small><i class="pi pi-user-edit"></i><strong>Assigned: </strong> {{ meetingDetails.agentName }}</small>
                </div>
            </ng-container>
        </p-dialog>
    </div>
</div>